import React from 'react';
import { ProgressBar } from 'react-bootstrap';

// DESIGN V2 passes `v2` (and `total`, the tracks in the run): a "3 of 14" count
// after the bar, and an icon for Stop instead of the × glyph.
const ProgressBarWithStop = ({ isProcessing, progress, handleStopProcessing, stage, v2 = false, total }) => {
    // IMPORTANT: always render the container and only toggle its visibility.
    // The progress bar lives inside the fixed-height `.upper-part`; if it were
    // mounted/unmounted (returning null when idle), adding it on "Analyze"
    // changes the number of flex children and reflows the layout — the
    // directory path jumps and the buttons slide. `visibility: hidden` keeps
    // the element's layout box reserved, so the idle and processing layouts are
    // identical and nothing moves when analysis starts/stops.
    return (
        <div
            className="progress-bar-container"
            style={{ visibility: isProcessing ? 'visible' : 'hidden' }}
            aria-hidden={!isProcessing}
        >
            <div className="progress-bar-wrapper">
                <div className="progress-bar-container-inner">
                    <ProgressBar
                        now={isProcessing ? progress : 0}
                        className="custom-progress-bar"
                    />
                </div>
                {v2 && (
                    <span className="v2-progress-count">
                        {total > 0 ? `${Math.min(total, Math.round(((progress || 0) / 100) * total))} of ${total}` : `${Math.round(progress || 0)}%`}
                    </span>
                )}
                <button
                    className="stop-button"
                    onClick={handleStopProcessing}
                    aria-label="Stop"
                    title="Stop processing"
                    tabIndex={isProcessing ? 0 : -1}
                >
                    {v2 ? (
                        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" /></svg>
                    ) : <>&times;</>}
                </button>
            </div>
            {/* What the run is doing before per-track work starts (tag reads,
                Mixpedia lookups). Without it the list sits still for the whole
                pre-pass and the run looks dead. Absolutely positioned so it
                costs no layout in any of the tabs that mount this bar. */}
            {stage ? <div className="progress-stage" title={stage}>{stage}</div> : null}
        </div>
    );
};

export default ProgressBarWithStop;
